import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as style from './MultiSelectList.styl';
function MultiSelectListItem(props) {
    const { getItemId, item, getItemComponent, onCheck, selected } = props;
    const identifier = getItemId(item);
    const itemNode = getItemComponent(item);
    return (_jsxs("div", Object.assign({ className: "multi-select-list-item" }, { children: [_jsxs("div", Object.assign({ className: "checkBoxContainer" }, { children: [_jsx("input", { id: `checkbox-${identifier}`, type: "checkbox", className: "checkbox", onChange: () => onCheck(item), checked: selected }), _jsx("label", { htmlFor: `checkbox-${identifier}` })] })), _jsx("div", Object.assign({ className: "multi-select-list-item-contents" }, { children: itemNode }))] }), `multi-select-list-item-${identifier}`));
}
export class MultiSelectList extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { initialized: false, selectedStateByIdentifier: {}, getItemId: (item) => item.id };
    }
    static getDerivedStateFromProps(nextProps, lastState) {
        if (lastState.initialized) {
            return null;
        }
        const { items, defaultToChecked, getItemSelected } = nextProps;
        let { getItemId } = nextProps;
        if (!getItemId) {
            getItemId = (item) => item.id;
        }
        const selectedStateByIdentifier = {};
        for (const item of items) {
            const identifier = getItemId(item);
            if (!identifier) {
                throw new Error("Items must have an 'id' prop or a getItemId getter must be provided");
            }
            if (getItemSelected) {
                selectedStateByIdentifier[identifier] = getItemSelected(item);
            }
            else if (defaultToChecked) {
                selectedStateByIdentifier[identifier] = true;
            }
            else {
                selectedStateByIdentifier[identifier] = false;
            }
        }
        const initialized = true;
        return {
            getItemId,
            initialized,
            selectedStateByIdentifier
        };
    }
    onCheck(checkedItem) {
        const selectedStateByIdentifier = Object.assign({}, this.state.selectedStateByIdentifier);
        const identifier = this.state.getItemId(checkedItem);
        selectedStateByIdentifier[identifier] = !selectedStateByIdentifier[identifier];
        const { items, onChange } = this.props;
        const { getItemId } = this.state;
        const selectedItems = items.filter((item) => selectedStateByIdentifier[getItemId(item)]);
        this.setState({ selectedStateByIdentifier });
        return onChange(selectedItems);
    }
    onCheckAll(allSelected) {
        const selectedStateByIdentifier = Object.assign({}, this.state.selectedStateByIdentifier);
        for (const key of Object.keys(selectedStateByIdentifier)) {
            selectedStateByIdentifier[key] = allSelected;
        }
        this.setState({ selectedStateByIdentifier });
        if (allSelected) {
            return this.props.onChange(Array.from(this.props.items));
        }
        return this.props.onChange([]);
    }
    render() {
        const { getItemComponent, headerText, items } = this.props;
        const { getItemId, selectedStateByIdentifier } = this.state;
        const onCheck = (item) => this.onCheck(item);
        const itemsToDisplay = items.map((item) => 
        // eslint-disable-next-line new-cap
        MultiSelectListItem({
            getItemId,
            getItemComponent,
            item,
            onCheck,
            selected: selectedStateByIdentifier[getItemId(item)]
        }));
        let allSelected = true;
        for (const key of Object.keys(selectedStateByIdentifier)) {
            if (!selectedStateByIdentifier[key]) {
                allSelected = false;
                break;
            }
        }
        return (_jsxs("div", Object.assign({ className: `multi-select-list ${style.global}` }, { children: [_jsxs("div", Object.assign({ className: "multi-select-list-header" }, { children: [_jsxs("div", Object.assign({ className: "checkBoxContainer" }, { children: [_jsx("input", { id: 'checkbox-multiselect', type: "checkbox", className: "checkbox", onChange: () => this.onCheckAll(!allSelected), checked: allSelected }), _jsx("label", { htmlFor: 'checkbox-multiselect' })] })), _jsx("label", Object.assign({ className: "multi-select-list-header-text" }, { children: headerText || 'Select All' }))] })), _jsx("div", Object.assign({ className: "multi-select-list-items" }, { children: itemsToDisplay }))] })));
    }
}
